import { api } from '@/providers/api';

interface GetUserInfoResponse {
  success: boolean;
  data: string;
}

interface GetUserInfoPayload {
  uid: string;
  token: string;
}

const usersApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getUserInfo: builder.mutation<string, GetUserInfoPayload>({
      query: (user) => ({
        url: `/v1/users/get-user-info`,
        method: 'GET',
        headers: {
          X_User_Id: user.uid,
          X_Token: user.token,
          X_Platform: 'web',
          X_pr: 'dev',
        },
      }),
      transformResponse: (response: GetUserInfoResponse): string =>
        response.data,
    }),
  }),
});

export const { useGetUserInfoMutation } = usersApi;
